<template>
<div>
  <div v-show="!troubleShootingDetailShow">
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r10">장애티켓 목록</div>
        <el-button v-if="!isKedbPopup && isAdmin" :disabled="!isDeleted" size="mini" @click="deleteTroubleTicket">삭제</el-button>
      </div>
      <div>
        <el-select v-model="searchDateField" style="width:90px" @change="loadData">
          <el-option v-for="item in searchDateFields" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-date-picker style="width: 200px" v-model="dateRange" type="daterange" :clearable="false" @change="changeDate" align="right" unlink-panels :range-separator="defaultDateRangeOptions.rangeSeparator" :start-placeholder="defaultDateRangeOptions.startPlaceholder"
          :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions" :default-time="defaultDateRangeOptions.defaultTime"></el-date-picker>
        <el-select v-model="searchType" style="width:80px">
          <el-option v-for="item in searchTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <w-search-field ref="searchField" width="200px" @search="searchTroubleShooting" />
        <el-button v-if="!isKedbPopup" size="small" style="height:28px !important" @click="exportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      </div>
    </el-row>
    <el-table-wrapper v-loading="loading" ref="troubleTicketTable" :data="troubleShootingData" :total="totalCount" :columns="columns" :pagination="true" remote @selection-change="onSelectionChange" @condition-change="loadData">
      <template slot-scope="scope" slot="subject">
        <span class="link" @click="clickTicketSubject(scope.row)">
          {{scope.row.subject}}
        </span>
      </template>
    </el-table-wrapper>
  </div>
  <w-event-ticket-status v-show="troubleShootingDetailShow" :isReadOnlyTicket="isKedbPopup" :is-popup-view="false" :params="troubleTicketDetailParams" @show-trouble-ticket-list="showTroubleTicketList" />
</div>
</template>

<script>
import moment from 'moment';
import msgUtil from '@/utils/message';
import { mapGetters } from 'vuex';
import { isNil, isEqual, cloneDeep, concat } from 'lodash';
import { isEmpty } from '@/utils/basic';
import { getDateToString, defaultDateRangeOptions } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';
import TroubleShootingAPI from '@/api/event/trouble-shooting';
import FileApi from '@/api/common/file';
import WSearchField from '@/components/form/SearchField';

export default {
  name: 'WTroubleTicket',
  components: {
    WEventTicketStatus: () => import('@/views/event/components/EventTicketStatus'),
    WSearchField,
  },
  props: {
    active: Boolean,
    viewType: {
      type: String,
      default: () => '',
    },
  },
  data() {
    const startDatetime = moment()
      .subtract(1, 'years')
      .startOf('day')
      .toDate();
    const endDatetime = moment()
      .endOf('day')
      .toDate();
    return {
      defaultDateRangeOptions,
      loading: false,
      totalCount: 0,
      dateRange: [startDatetime, endDatetime],
      searchType: 'subject',
      searchValue: null,
      searchDateField: 'write_datetime',
      searchDateFields: [
        {
          value: 'write_datetime',
          label: '발행일시',
        },
        {
          value: 'last_edit_datetime',
          label: '처리일시',
        },
      ],
      searchTypeOption: [
        {
          value: 'subject',
          label: '제목',
        },
        {
          value: 'comment',
          label: '내용',
        },
        {
          value: 'writer_id',
          label: '발행자',
        },
        {
          value: 'last_editer_id',
          label: '처리자',
        },
      ],
      /**
       * 장애 티켓 컬럼
       * @type {Array}
       */
      troubleTicketColumns: [
        {
          prop: 'troubleTicketGroupId',
          label: 'No',
          width: '80px',
          sortable: true,
        },
        {
          prop: 'subject',
          label: '제목',
          sortable: true,
          scopedSlot: 'subject',
        },
        {
          prop: 'writerId',
          label: '발행자',
          width: '130px',
          sortable: true,
        },
        {
          prop: 'lastEditerId',
          label: '처리자',
          width: '130px',
          sortable: true,
        },
        {
          prop: 'writeDatetime',
          label: '발행일시',
          width: '130px',
          sortable: true,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'lastEditDatetime',
          label: '처리일시',
          width: '130px',
          sortable: true,
          formatter: this.getDateFormatter,
        },
        {
          prop: 'troubleStatusName',
          label: '처리현황',
          width: '90px',
          sortable: true,
        },
      ],
      troubleShootingData: [],
      troubleTicketDetailParams: null,
      troubleTicketTableParams: null,
      troubleShootingDetailShow: false,
      selectionTickets: [], // 선택한 장애티켓의 정보를 확인한다.
    };
  },
  computed: {
    /**
     * 어드민 권한 여부
     * @author Ju
     * @return {Boolean}]
     */
    isAdmin() {
      return this.userInfo.managerType === 'ADMIN';
    },
    /**
     * KEDB 팝업에서 연관 장애티켓으로 불러와진 뷰인지 확인하는 플래그
     * @author yelim
     * @return {Boolean}
     */
    isKedbPopup() {
      if (this.viewType === 'kedbPopup') {
        return true;
      }
      return false;
    },
    /**
     * 선택한 장애티켓 항목이 한개 이상인 경우 삭제할 수 있다.
     * @author yelim
     * @return {Boolean}
     */
    isDeleted() {
      return !isNil(this.selectionTickets) && this.selectionTickets.length > 0;
    },
    /**
     * 장애 티켓 컬럼 (권한 처리)
     * @author Ju
     * @return {Array} [description]
     */
    columns() {
      if (this.isAdmin) {
        const columns = cloneDeep(this.troubleTicketColumns);
        return concat(
          [
            {
              type: 'selection',
              width: 55,
            },
          ],
          columns,
        );
      }
      return this.troubleTicketColumns;
    },
    ...mapGetters(['selectedNode', 'activeTab', 'userInfo']),
  },
  watch: {
    selectedNode: {
      immediate: true,
      handler() {
        this.troubleShootingDetailShow = false;
        this.loadPage(1);
      },
    },
    active: {
      handler(value) {
        if (!isNil(value) && value) {
          this.$store.dispatch('setSelectedEvents', []);
          this.loadPage(1);
        }
      },
    },
    troubleShootingDetailShow: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.troubleTicketDetailParams = null;
        }
      },
    },
  },
  mounted() {
    // frame/index.vue에서 관리중이나 혹시 모를 예외 상황을 위해 일단 유지.
    OperationSettingsAPI.getUrgencyAndImpactBasicData().then((res) => {
      if (res.data.success) {
        this.$store.dispatch('setUrgencyData', res.data.data.urgencyList);
        this.$store.dispatch('setImpactData', res.data.data.impactList);
      }
    });
  },
  methods: {
    /**
     * 장애 티켓 목록을 조회한다.
     */
    loadData() {
      if (isNil(this.active) || !this.active || isNil(this.selectedNode) || isNil(this.selectedNode.type)) {
        return;
      }
      const treeType = this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
      const tableParams = this.$refs.troubleTicketTable.getParameter();
      const pagination = this.$refs.troubleTicketTable.getPagination();
      const params = {
        ...tableParams,
        treeType,
        pageSize: pagination.pageSize,
        type: this.selectedNode.type,
        searchType: this.searchType,
        searchDateField: this.searchDateField,
        searchValue: this.searchValue,
        startDatetime: this.dateRange[0].getTime(),
        endDatetime: this.dateRange[1].getTime(),
      };
      if (this.isKedbPopup === false) {
        if (isEqual(treeType, 'logical')) {
          if (isEqual(params.type, 'group')) {
            if (this.selectedNode.subType === 'virtual') {
              params.objId = this.selectedNode.objId;
              params.objtypeId = this.selectedNode.obj.objtypeId;
              params.subType = this.selectedNode.subType;
            } else {
              params.managegroupIds = this.selectedNode.childManagegroupIds;
            }
          } else if (isEqual(params.type, 'obj')) {
            if (!isEqual(this.selectedNode.subType, 'e2e')) {
              params.objId = this.selectedNode.obj.objId;
            }
          }
        } else if (isEqual(treeType, 'physical')) {
          if (isEqual(params.type, 'group')) {
            params.subType = this.selectedNode.subType;
            params.managetypeId = this.selectedNode.managetypeId;
            params.objtypeId = this.selectedNode.objtypeId;
            // nms일 경우
            params.objCompanyId = this.selectedNode.objCompanyId;
            // vms일 경우
            params.hypervisorType = this.selectedNode.hypervisorType;
            params.virtualcenterGroupId = this.selectedNode.virtualcenterGroupId;
            params.objId = this.selectedNode.objId;
          } else if (isEqual(params.type, 'obj')) {
            params.objId = this.selectedNode.obj.objId;
          }
        }
      }
      this.loading = true;
      TroubleShootingAPI.getTroubleShootingList(params)
        .then((response) => {
          if (response.data.success) {
            if (isEmpty(response.data.data) && response.data.total !== 0) {
              this.loadPage(response.data.lastPage);
            } else {
              this.troubleTicketTableParams = params;
              this.troubleShootingData = response.data.data;
              this.totalCount = response.data.total;
              const groupIdInfo = [];
              this.troubleShootingData.forEach((item) => {
                groupIdInfo.push({
                  troubleTicketGroupId: item.troubleTicketGroupId,
                  nextId: item.nextTicketId,
                  prevId: item.prevTicketId,
                });
              });
              this.ticketIdsList = groupIdInfo;
            }
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '장애 티켓', false));
          throw new Error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 장애 티켓 특정 페이지 데이터를 호드한다.
     * @author Ju
     * @param  {[type]} page [description]
     * @return {[type]}      [description]
     */
    loadPage(page) {
      if (this.$refs.troubleTicketTable) {
        this.$refs.troubleTicketTable.setCurrentPage(page);
      } else {
        this.$nextTick(() => {
          this.$refs.troubleTicketTable.setCurrentPage(page);
        });
      }
    },
    /**
     * 장애 티켓 검색
     * @param  {String} keyword [description]
     * @return {[type]}   [description]
     */
    searchTroubleShooting(keyword) {
      this.searchValue = keyword;
      this.loadData();
    },
    /**
     * 장애 티켓 제목 클릭 이벤트 핸들러
     * @param  {[type]} targetTroubleTicketInfo [description]
     * @return {[type]}                         [description]
     */
    clickTicketSubject(targetTroubleTicketInfo) {
      this.troubleTicketDetailParams = {
        troubleTicketGroupId: targetTroubleTicketInfo.troubleTicketGroupId,
        tableParams: this.troubleTicketTableParams,
      };
      this.troubleShootingDetailShow = true;
    },
    /**
     * 장애 티켓 목록을 제공한다.
     * @author Ju
     * @return {[type]} [description]
     */
    showTroubleTicketList() {
      this.troubleShootingDetailShow = false;
      this.loadData();
    },
    /**
     * 장애 티켓 조회 날짜 범위 변경
     */
    changeDate() {
      this.loadData();
    },
    /**
     * 장애티켓 목록을 엑셀출력한다.
     * @return {[type]} [description]
     * @author jda
     */
    exportExcel() {
      const params = {
        type: this.selectedNode.type,
        searchType: this.searchType,
        searchValue: this.searchValue,
        startDatetime: this.dateRange[0].getTime(),
        endDatetime: this.dateRange[1].getTime(),
      };

      if (isEqual(params.type, 'group')) {
        if (this.selectedNode.subType === 'virtual') {
          params.objId = this.selectedNode.objId;
          params.objtypeId = this.selectedNode.obj.objtypeId;
          params.subType = this.selectedNode.subType;
        } else {
          params.managegroupIds = this.selectedNode.childManagegroupIds;
        }
      } else if (isEqual(params.type, 'obj')) {
        if (!isEqual(this.selectedNode.subType, 'e2e')) {
          params.objId = this.selectedNode.obj.objId;
        }
      }
      TroubleShootingAPI.getTroubleShootingExcel(params)
        .then((response) => {
          if (response.data.success && !isEmpty(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getCustomResultMsgData('엑셀로 출력하지 못하였습니다.', false));
          }
        })
        .catch((e) => {
          this.$message(msgUtil.getCustomResultMsgData('엑셀로 출력하지 못하였습니다.', false));
          throw new Error(e);
        });
    },
    /**
     * [장애티켓 삭제 또는 KEDB 추가하는 경우 연관 장애티켓 저장시 선택한 항목 정보 저장]
     * @author yelim
     */
    onSelectionChange(selection) {
      this.selectionTickets = selection;
    },
    /**
     * 계정이 Admin 권한인 경우 장애티켓을 삭제한다.
     * @author yelim
     */
    deleteTroubleTicket() {
      const deleteGroupIdList = [];
      this.selectionTickets.forEach((item) => {
        deleteGroupIdList.push({
          troubleTicketGroupId: item.troubleTicketGroupId,
        });
      });
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        TroubleShootingAPI.deleteTroubleShootingList(deleteGroupIdList)
          .then((response) => {
            if (response.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '장애티켓', true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '장애티켓', false));
            }
          })
          .catch((e) => {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '장애티켓', false));
            throw new Error(e);
          });
      });
    },
    /**
     * 장애 티켓 처리 현황 상태 값 반환
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getTroubleStatus(row, column, value) {
      let status = '처리 완료';
      if (isEqual(value, 'R')) {
        status = '처리 중';
      }
      return status;
    },
    /**
     * date formatter
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    /**
     * 연관 장애티켓 추가 팝업 검색시 검색조건 초기화
     * @author yelim
     */
    resetSearchCondition() {
      const startDatetime = moment()
        .subtract(1, 'years')
        .startOf('day')
        .toDate();
      const endDatetime = moment()
        .endOf('day')
        .toDate();
      this.searchDateField = 'write_datetime';
      this.dateRange = [startDatetime, endDatetime];
      this.searchType = 'subject';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/trouble-ticket/index.vue